// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'lock-open-solid';

export const Component = () => (
  <path d='M7.928 10.818h11.255c.431 0 .766.144 1.054.431.287.288.431.623.431 1.006v9.865c0 .432-.144.767-.431 1.054a1.408 1.408 0 0 1-1.054.431H5.485a1.41 1.41 0 0 1-1.054-.43A1.408 1.408 0 0 1 4 22.12v-9.865c0-.383.144-.72.431-1.006a1.411 1.411 0 0 1 1.054-.431h1.437V6.412c0-1.485.526-2.778 1.58-3.832C9.556 1.527 10.85 1 12.334 1s2.778.527 3.83 1.58c1.054 1.054 1.581 2.347 1.581 3.832v.958c0 .335-.191.478-.526.478s-.48-.143-.48-.478v-.958c0-1.198-.43-2.251-1.292-3.114-.91-.91-1.916-1.34-3.113-1.34-1.198 0-2.204.431-3.114 1.34-.861.862-1.293 1.916-1.293 3.114v4.406h.001Zm6.37 8.86a.977.977 0 0 0-.288-.719.973.973 0 0 0-.719-.287h-1.915a.977.977 0 0 0-.719.287.973.973 0 0 0-.287.72.95.95 0 0 0 .287.67.976.976 0 0 0 .719.287h1.915a.977.977 0 0 0 .72-.288.943.943 0 0 0 .287-.67Z' />
);

export const viewBox = '0 0 25 25';
